// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import type { Channel } from "@anycable/core";
import { getCurrentScope, onScopeDispose } from "vue";
import { getCable } from "../internalCableClient";

type ChannelMessage<C> = C extends Channel<infer _P, infer M> ? M : never;

export interface ChannelHandlers<M> {
  onMessage: (data: M) => void;
  onConnect?: () => void;
  onDisconnect?: () => void;
}

/** Subscribe a channel via the app cable and tear it down with the effect scope. */
export function subscribeChannel<C extends Channel>(
  channel: C,
  handlers: ChannelHandlers<ChannelMessage<C>>,
): C {
  getCable().subscribe(channel);
  channel.on("message", (data) => handlers.onMessage(data as ChannelMessage<C>));
  if (handlers.onConnect) channel.on("connect", handlers.onConnect);
  if (handlers.onDisconnect) channel.on("disconnect", handlers.onDisconnect);
  if (getCurrentScope()) onScopeDispose(() => channel.disconnect());
  return channel;
}
